import React, { useState, useEffect, useRef } from 'react'
import './admin.styles.scss'

import { Routes, Route, useNavigate, useLocation } from 'react-router-dom'

import Header from '@/components/header/header.component'
import CreateEval from '@/components/ADMIN/create-eval/create-eval.component'
import EvalData from '@/components/ADMIN/eval-data/eval-data.component'
import Footer from '@/components/footer/footer.component'

import { useSelector, useDispatch } from 'react-redux'
// import { setEvalList } from '@/state/slices/listsSlice'

import { ref, child, get, off } from "firebase/database";
import { rtDb } from '@/utils/firebase.utils'
import Header2025 from '../../components/header-2025/header-2025.component'
import ManageEvals from '../../components/ADMIN/manage-evals/manage-evals.component'
import AdminFunctions from '../../components/ADMIN/functions/admin-functions.component'
import EvalDataV2 from '../../components/ADMIN/eval-data/eval-data-v2.component'
import { getEvalListFromRtDb } from '../../utils/getDataFromDb'
import AdminUsers from '../../components/ADMIN/users/admin-users.component'

const AdminPage = () => {

	// const evalList = useSelector(state => state.listsData.evalList);
	const userProfile = useSelector(state => state.userData.userProfile);
	const [ tabs, setTabs ] = useState(null);
	const [ evalList, setEvalList ] = useState(null);
	const [ source ] = useState('none');
	const dataRef = useRef();
	const navigate = useNavigate();
	const location = useLocation();
	let evalListener;

	useEffect(() => {

		return () => {
			if (evalListener) off(evalListener);
		}
	}, [])

	useEffect(() => {
		if (location.pathname === '/admin' || location.pathname === '/admin/') {
			navigate('/admin/evals')
		}
	}, [location])

	useEffect(() => {
		
		console.log('running useEffect')
		// updateLists();
        getEvalsFromDB();
		const tabArr = [
			{
				'id': 'getData',
				'title': 'Data Overview',
				'href': '/admin/data',
				'selected': 'not_selected'
			},
			{
				'id': 'manageEvals',
				'title': 'Manage Evaluations',
				'href': '/admin/evals',
				'selected': 'not_selected'
			},
			{
				'id': 'manageUsers',
				'title': 'Manage Users',
				'href': '/admin/users',
				'selected': 'not_selected'
			},
			{
				'id': 'createEvals',
				'title': 'Create an Evaluation',
				'href': '/admin/create',
				'selected': 'selected'
			},
			
		]
		if (userProfile && userProfile.email === 'adam.geisen@ilprincipals.org') {
			tabArr.push({
				'id': 'adminFunctions',
				'title': 'Admin Functions',
				'href': '/admin/functions',
				'selected': 'not_selected'
			});
		}
		setTabs(tabArr);
	}, [userProfile])
	
	const getEvalsFromDB = async (e) => {
		getEvalListFromRtDb({
			'callback': callback,
			'handleListener': handleListener
		})
		function callback(data) {
			dataRef.current = {
				...dataRef.current,
				...{[data.id]: data}
			}
			setEvalList(dataRef.current);
		}
		function handleListener(rtDocRef) {
			evalListener = rtDocRef;
		}
		
	}

	
	
	return (
		<div className='admin_page'>
			<Header2025 tabs={tabs} source={source} />
			<div className='admin_content'>
				<div className='admin_grid'	>
					<div className='admin_sidebar'>
						{
							(tabs && location) &&
							<div className='admin_sidebar_buttons g-card'>
								{
									tabs.map(tab => (
										<button 
											key={tab.id} 
											href={tab.href} 
											className={`g-button med-btn ${
												location.pathname.includes(tab.href) 
												? 'active' 
												: ''}`
											}
											onClick={() => navigate(tab.href)}
										>
											{tab.title}
										</button>
									))
								}
							</div>
						}
					</div>
					<div className='admin_main'>
						<Routes>
							<Route path='/create' element={
								<CreateEval />
							}></Route>
							<Route path='/evals/*' element={
								<ManageEvals evalList={evalList} />
							}></Route>
							<Route path='/users/*' element={
								<AdminUsers />
							}></Route>
							<Route path='/data' element={
								<EvalDataV2 evalList={evalList} />
							}></Route>
							<Route path='/functions' element={
								<AdminFunctions />
							}></Route>
						</Routes>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	)
}

export default AdminPage